export default {
  show(state, id) {
    state.conversationId = id || null;
    state.open = true;
  },
  close(state) {
    state.open = false;
    state.conversationId = null;
  }
};
